/* Función para determinar si esta vacio un json */
exports.isEmptyJSON = (obj) => {
  for(var i in obj){
    return true;
  }
  return false;
}



// WEBPACK FOOTER //
// ./src/functions/functions.js